const translations: Record<string, string> = {
  // ── Forecast page (/forecast) ──
  fc_loading_data: 'Loading forecast data…',
  fc_load_error_title: 'Forecast load error',
  fc_demo_banner: 'Backend unavailable — showing demo forecast data',
  fc_footer_updated: 'Updated',
  fc_footer_model: 'Model',
  fc_footer_refresh: 'Refresh every 5 min',
  fc_today: 'Today',
  fc_sum_title: 'Podsumowanie doby',
  fc_map_reset: 'Przywróć widok mapy',
  fc_sum_as_of: 'na godz. {{hour}}',
  fc_sum_final: 'doba zakończona',
  fc_sum_day_plan: 'Prognoza na całą dobę',
  fc_sum_day_actual: 'Fakt za dobę',

  // KPI row
  fc_kpi_total_energy: 'Forecast generation',
  fc_kpi_max_hourly: 'Max hourly forecast (today)',
  fc_kpi_actual_pv: 'Actual generation',
  fc_current: 'current forecast',

  // Main chart
  fc_loading_hourly_cmp: 'Loading forecast comparison…',
  fc_loading_30min_cmp: 'Loading 30-min forecast comparison…',
  fc_title_hourly: 'Hourly forecast comparison',
  fc_title_30min: '30-minute forecast comparison',
  fc_active_label: 'Active',
  fc_active_title: 'Model the system actually uses for this asset (DAM/digest)',
  fc_mode_hourly: 'Hourly',
  fc_mode_30min: '30-minute',
  fc_available_points: 'Available points',
  fc_actual_points: 'Actual points',
  fc_series_actual: 'Actual PV',
  fc_ecmwf_title: 'v0.2.2 model on ECMWF IFS 0.25° inputs instead of Open-Meteo (ICON). Test period 5-7 days.',
  fc_empty_30min_title: '30-minute forecast not available',
  fc_empty_30min_body: 'The 30-min generator is not currently scheduled. Switch to hourly mode to see the current v0.2.2 forecast.',
  fc_switch_hourly: 'Switch to hourly',

  // Summary cards
  fc_sum_forecast_energy: 'Forecast energy',
  fc_approx: 'approx',
  fc_sum_actual_energy: 'Actual energy',
  fc_sum_abs_error: 'Abs error',
  fc_sum_rows_forecast: 'Rows with forecast',
  fc_sum_rows_actual: 'Rows with actual',
  fc_interval: 'Interval',
  fc_30min_short: '30 min',
  fc_sum_actual: 'Actual',
  fc_sum_base_abs_error: 'Base abs error',

  // Tooltip labels
  fc_tt_actual_pv_kw: 'Actual PV, kW',
  fc_tt_actual_pv_kwh: 'Actual PV, kWh',
  fc_tt_delta_vs_base_kw: 'Δ vs base, kW',
  fc_tt_delta_vs_base_pct: 'Δ vs base, %',
  fc_tt_calibration: 'Calibration',
  fc_tt_calibration_mode: 'Calibration mode',
  fc_tt_calibration_weight: 'Calibration weight',
  fc_tt_bess_charge: 'BESS charge, kW',
  fc_tt_bess_discharge: 'BESS discharge, kW',
  fc_tt_bess_power: 'BESS power, kW',
  fc_tt_cloud_pct: 'Cloud, %',
  fc_tt_cloud_lmh: 'Cloud L/M/H',
  fc_tt_cloud_cover_pct: 'Cloud cover, %',
  fc_tt_shortwave: 'Shortwave',
  fc_tt_direct: 'Direct',
  fc_tt_shortwave_rad: 'Shortwave radiation',
  fc_tt_direct_rad: 'Direct radiation',
  fc_tt_diffuse_rad: 'Diffuse radiation',
  fc_tt_weather_interp: 'Weather interpolation',
  fc_tt_temp_2m: 'Temperature 2m',
  fc_tt_forecast_slot: 'Forecast slot',
  fc_tt_no_forecast_slot: 'No forecast for this slot',
  fc_tt_no_actual_yet: 'No actual data yet',
  fc_tt_delta_kw: 'Delta, kW',
  fc_tt_delta_pct: 'Delta, %',
  fc_tt_abs_error_kw: 'Abs error, kW',
  fc_tt_coverage: 'Coverage',
  fc_tt_quality_flag: 'Quality flag',
  fc_tt_bess_quality_flag: 'BESS quality flag',
  fc_tt_delta_severity: 'Delta severity',

  // Deviation table
  fc_loading_hourly: 'Loading hourly data…',
  fc_dev_title: 'Hourly forecast vs actual',
  fc_dev_sum_forecast: 'forecast',
  fc_dev_sum_actual: 'actual',
  fc_refresh_title: 'Refresh data',
  fc_active_only: 'Active hrs',
  fc_all_hours: 'All hrs',
  fc_col_hour: 'Hour',
  fc_col_forecast_kwh: 'Forecast, kWh',
  fc_col_actual_88: 'Actual 8/8',
  fc_col_shortwave: 'Shortwave',
  fc_col_cloud: 'Cloud',
  fc_col_cloud_lmh: 'Cloud L/M/H',
  fc_col_temp: 'Temp',
  fc_col_sev: 'Sev.',
  fc_col_status: 'Status',
  fc_sev_zero_ok: 'Zero OK',
  fc_sev_f0: 'F=0',
  fc_sev_low: 'Low',
  fc_sev_high: 'High',
  fc_sev_critical: 'Critical',
  fc_st_future: 'Future',
  fc_st_live: 'Live',
  fc_st_final: 'Final',
  fc_st_no_data: 'No data',

  // Export modal
  fc_export_title: 'Export forecast data',
  fc_date_from: 'Date from',
  fc_date_to: 'Date to',
  fc_coming_soon: 'Coming soon',
  fc_cancel: 'Cancel',
  fc_download_xlsx: 'Download XLSX',
  fc_preparing: 'Preparing...',
  fc_preparing_export: 'Preparing export...',
  fc_err_date_order: 'Date From must be before or equal to Date To',
  fc_err_export_failed: 'Export failed. Please try again.',
};

export default translations;
